import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { queryClient } from '@as-react/common-queries';
import { Environment, GLOSSARY_HIGHLIGHT_CLASS, initHighlightGlossaryItems, uniqueId, } from '@as-react/common-utils';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Tooltip } from '@yonderland/andes-react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useZitcha } from '../../hooks/useZitcha';
import { HtmlInclude } from '../common/html-include/HtmlInclude';
const useGlossary = () => {
    const { glossaryPath, servicesApiPrefixAemServices } = useAemConfig();
    const endpoint = Environment.isDevelopment() ? 'http://localhost:4502/' : servicesApiPrefixAemServices;
    return useQuery({
        queryKey: ['glossary', glossaryPath],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield axios.get(`${endpoint}services/public/glossary?site=${glossaryPath}`);
            window.glossary = data;
            return data;
        }),
        enabled: !window.glossary,
    });
};
const Bootstrap = () => {
    const { collectPageview } = useZitcha();
    const [highlightedItems, setHighlightedItems] = useState();
    useGlossary();
    useEffect(() => {
        collectPageview();
        setTimeout(() => {
            setHighlightedItems(initHighlightGlossaryItems(`.${GLOSSARY_HIGHLIGHT_CLASS}`));
        }, 2000);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(ReactQueryDevtools, { client: queryClient }), highlightedItems === null || highlightedItems === void 0 ? void 0 : highlightedItems.map(({ element, glossaryItem }, index) => (_jsx(Tooltip, { targetElement: element, title: glossaryItem.title, text: _jsx(HtmlInclude, { htmlFragment: glossaryItem.description }) }, `${glossaryItem.title}-${uniqueId()}-${index}`)))] }));
};
export default Bootstrap;
